import { defineComponent, reactive, ref, watch, toRefs } from "vue";
import { ElMessage, ElMessageBox, ElForm } from 'element-plus';
export default defineComponent({
  components: {},
  name: '',
  props: {
    defaultTime: {
      type: String,
      default: ''
    }
  },
  setup(props, {
    emit
  }) {
    const state = reactive({
      dayValue: new Date(),
      value2: [],
      dateType: "day",
      radioData: [{
        label: 'day',
        labelName: '日'
      }, {
        label: 'month',
        labelName: '月'
      }, {
        label: 'year',
        labelName: '年'
      }]
    });
    const methods = reactive({
      radioChange(val) {
        state.dayValue = "";
        state.value2 = [];
        emit('radioChange', val);
        if (state.dateType == "month") {
          let oldData = methods.getLastMonth();
          let nowData = methods.getNowData(new Date());
          state.value2 = [oldData, nowData];
          emit('selectChange', state.value2);
        } else if (state.dateType == "year") {
          console.log("年年", methods.getYear());
          state.value2 = [methods.getYear(), methods.getNowYear()];
          emit('selectChange', state.value2);
        } else if (state.dateType == "day") {
          state.dayValue = methods.getNowData(new Date());
          emit('selectChange', state.dayValue);
        }
      },
      selectChange(val) {
        if (state.dateType == "day") {
          let dayValue = methods.getNowData(val);
          emit('selectChange', dayValue);
        } else if (state.dateType == "year") {
          let start = parseInt(val[0].split('-')[0]) * 12 + parseInt(val[0].split('-')[1]);
          let end = parseInt(val[1].split('-')[0]) * 12 + parseInt(val[1].split('-')[1]);
          if (Math.abs(start - end) > 11) {
            ElMessage.warning('请选择相差小于12个月日期');
            state.value2 = [];
          } else {
            emit('selectChange', val);
          }
        } else {
          emit('selectChange', val);
        }
      },
      //当前年
      getNowYear() {
        let year = new Date().getFullYear();
        let mon = new Date().getMonth() + 1;
        let day = "-01";
        mon = mon < 10 ? "0" + mon : mon;
        return year + "-" + mon + day;
      },
      //获取前十二个月
      getYear() {
        let year = new Date().getFullYear();
        let mon = new Date().getMonth() + 1;
        let day = "-01";
        if (mon == 12) {
          mon = 1;
        } else {
          year--;
          mon++;
        }
        mon = mon < 10 ? "0" + mon : mon;
        return year + "-" + mon + day;
      },
      //获取前三十天日期
      getLastMonth() {
        //先获取当前日期
        let data = new Date();
        let year = data.getFullYear();
        //当前月份需要加一
        let mon = data.getMonth() + 1;
        let day = data.getDate();
        //一月的时候年份要减一
        if (mon == 1) {
          year--;
          mon = 12;
        } else if (mon == 3 && day > 28) {
          //三月要考虑是否为闰年
          mon--;
          if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
            day = 29;
          } else {
            day = 28;
          }
        } else if (mon != 12 || mon != 8 && day == 31) {
          //31号的月份要考虑上个月是否有31号
          mon--;
          day == 30;
        } else {
          mon--;
        }
        mon = mon < 10 ? "0" + mon : mon;
        day = day < 10 ? "0" + day : day;
        //最后拼接年月日
        return year + "-" + mon + "-" + day;
      },
      //获取当前日期格式化
      getNowData(val) {
        let year = val.getFullYear();
        let month = val.getMonth() + 1 < 10 ? "0" + (val.getMonth() + 1) : val.getMonth() + 1;
        let d = val.getDate() < 10 ? "0" + val.getDate() : val.getDate();
        return year + '-' + month + '-' + d;
      }
    });
    //变量
    let chooseDay = ref(null);
    const handleChange = val => {
      chooseDay.value = val;
    };
    //取值方法
    const handleFocus = () => {
      chooseDay.value = null;
    };
    const disabledDateTWO = time => {
      if (time.getTime() > new Date().getTime()) {
        return time.getTime() >= new Date().getTime();
      }
    };
    const disabledDateOne = time => {
      if (time.getTime() > new Date().getTime()) {
        return time.getTime() >= new Date().getTime();
      }
    };
    const disabledDate = time => {
      if (time.getTime() > new Date().getTime()) {
        return time.getTime() >= new Date().getTime();
      }
      if (!chooseDay.value) {
        return false;
      }
      let timeRange = 30;
      let con1 = new Date(chooseDay.value).getTime() - timeRange * 24 * 60 * 60 * 1000;
      let con2 = new Date(chooseDay.value).getTime() + timeRange * 24 * 60 * 60 * 1000;
      return time < con1 || time > con2;
    };
    methods.selectChange(new Date());
    watch(() => props.defaultTime, val => {
      if (state.dateType == 'day') {
        state.dayValue = val;
      }
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      chooseDay,
      handleChange,
      handleFocus,
      disabledDate,
      disabledDateOne,
      disabledDateTWO
    };
  }
});